<template>
  <div>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      identifier="employerPaymentsTable"
      @error="error = $event"
      :showSelect="false"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :sortBy="'PaymentDate'"
      :sortDescending="true"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200">
      <material-card
        v-if="payment !== null && payment !== undefined"
        :title="
          $t('components.balancepayments.paymentstable.edit_title_{0}', [
            payment.PaymentNumber,
          ])
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="edit"
      >
        <payment-form
          ref="editPaymentForm"
          :terms="terms"
          :payment="payment"
          @close="
            dialogs.edit = false;
            payment = null;
          "
          @update="update"
          :saving="saving"
        />
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="1200">
      <material-card
        v-if="payment !== null && payment !== undefined"
        :title="
          $t(
            'components.balancepayments.paymentstable.delete_warning_title_{0}',
            [payment.PaymentNumber]
          )
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{
            $t(
              "globals.are_you_sure"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.delete = false" :loading="saving">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" :loading="saving" @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="dialogs.add" persistent max-width="1200">
      <material-card
        :title="$t('components.balancepayments.paymentstable.add_title')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <payment-form
          ref="addPaymentForm"
          :terms="terms"
          :payment="payment"
          @close="
            dialogs.add = false;
            payment = null;
          "
          @add="add"
          :saving="saving"
        />
      </material-card>
    </v-dialog>
    <!-- <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../ErrorHandler.vue";
import { ODataProvider } from "pbas-vue-components";
import { locker } from "../../mixins/locker";
import { planSetter } from "../../mixins/planSetter";
import PaymentsHeaders from "../../headers/Payments";
import PaymentForm from "./PaymentForm.vue";

export default {
  name: "payments-table",
  components: {
    ErrorHandler,
    PaymentForm,
  },
  mixins: [locker, planSetter],
  props: ["employer"],
  data() {
    return {
      // firstRun: true,
      loading: false,
      terms: [],
      saving: false,
      error: null,
      provider: undefined,
      headers: PaymentsHeaders,
      payment: null,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.payment = JSON.parse(JSON.stringify(item));
            this.dialogs.edit = true;
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.payment = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
        },
      ],
      floatActions: [
        {
          text: "globals.add",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: () => {
            this.payment = {
              EmployerId: this.employer.Id,
              Term: {
                Translations: [],
              },
            };
            this.dialogs.add = true;
          },
        },
      ],
      dialogs: {
        edit: false,
        delete: false,
        add: false,
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planIdentity: "planIdentity",
    }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.provider = undefined;
        if (this.employer !== null && this.employer !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
    employer: {
      handler() {
        this.provider = undefined;
        if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
          this.$nextTick(() => {
            this.loadPlanData();
          });
        }
      },
    },
  },
  mounted() {
    if (
      this.selectedPlan !== null &&
      this.selectedPlan !== undefined &&
      this.employer !== null &&
      this.employer !== undefined
    ) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "newPayment",
      "updatePayment",
      "deletePayment",
      "getEmployerPaymentTerms",
    ]),
    async loadPlanData() {
      // this.loading = true;
      const url = `plans/${this.selectedPlan.Id}/employers/${
        this.employer.Id
      }/payments`;
      this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
      try {
        this.terms = (await this.getEmployerPaymentTerms({
          planIdentityId: this.selectedPlan.Id,
          employerId: this.employer.Id,
        })).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        // this.loading = false;
        // if (this.firstRun) {
        //   this.firstRun = false;
        // } else {
        //   this.$refs.table.getDataAsync();
        // }
      }
    },
    async update() {
      this.saving = true;
      let item = JSON.parse(JSON.stringify(this.payment));
      item.TermId = item.Term.Id;
      delete item.Term;
      item.EmployerId = this.employer.Id;
      item.PlanId = this.selectedPlan.Id;
      item.Amount = parseFloat(item.Amount);
      try {
        await this.updatePayment({
          planIdentityId: this.selectedPlan.Id,
          paymentId: item.Id,
          payload: item,
        });
        this.$refs.table.getDataAsync();
        this.dialogs.edit = false;
        this.payment = null;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async add() {
      this.saving = true;
      let item = JSON.parse(JSON.stringify(this.payment));
      item.TermId = item.Term.Id;
      delete item.Term;
      item.EmployerId = this.employer.Id;
      item.PlanId = this.selectedPlan.Id;
      item.Amount = parseFloat(item.Amount);
      try {
        await this.newPayment({
          planIdentityId: this.selectedPlan.Id,
          payload: item,
        });
        this.$refs.table.getDataAsync();
        this.dialogs.add = false;
        this.payment = null;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async tryDelete() {
      this.saving = true;
      try {
        await this.deletePayment({
          planIdentityId: this.selectedPlan.Id,
          paymentId: this.payment.Id,
        });
        this.dialogs.delete = false;
        this.$refs.table.getDataAsync();
        this.dialogs.delete = false;
        this.payment = null;
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
